import { Box, Button, ButtonGroup } from "@material-ui/core";
import React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { BORDER_COLOR, SECONDARY_COLOR } from "../../../../../../ui/theme/createMaterialTheme";
import { TimePeriodFilter, titleForTimePeriod } from "../../../model/TimePeriodFilter";

interface Props extends WithTranslation {
  selectedPeriod: TimePeriodFilter;
  onPeriodChanged: (period: TimePeriodFilter) => void;
}

const TimePeriodToggle = ({ selectedPeriod, onPeriodChanged, t }: Props) => {
  const renderButton = (period: TimePeriodFilter) => {
    const isSelected = selectedPeriod === period;

    return (
      <Button
        onClick={() => onPeriodChanged(period)}
        style={{
          color: isSelected ? SECONDARY_COLOR : "rgba(0, 0, 0, 0.54)",
          borderColor: isSelected ? SECONDARY_COLOR : BORDER_COLOR,
          borderWidth: isSelected ? 2 : 1,
          fontWeight: isSelected ? 700 : 400,
          textTransform: "none",
        }}
      >
        {titleForTimePeriod(period, t)}
      </Button>
    );
  };

  return (
    <Box width="100%">
      <ButtonGroup fullWidth variant="outlined" disableElevation>
        {renderButton("12_months")}
        {renderButton("all_time")}
      </ButtonGroup>
    </Box>
  );
};

export default withTranslation()(TimePeriodToggle);
